import {
  EuiBasicTable,
  EuiButtonEmpty,
  EuiButtonIcon,
  EuiFieldText,
  EuiFormRow,
  EuiTableComputedColumnType,
} from "@inscopix/ideas-eui";

const columns: EuiTableComputedColumnType<{
  disabled: boolean;
  value: string | number;
  setValue: (value: string) => void;
  removeChoice: () => void;
}>[] = [
  {
    name: "Value",
    render: ({ disabled, value, setValue }) => {
      return (
        <EuiFieldText
          fullWidth
          compressed
          placeholder=""
          disabled={disabled}
          value={value}
          onChange={(e) => {
            const newValue = e.target.value;
            setValue(newValue);
          }}
        />
      );
    },
  },
  {
    width: "50px",
    render: ({ removeChoice }) => {
      return (
        <EuiButtonIcon
          aria-label="Remove choice"
          color="danger"
          iconType="cross"
          onClick={removeChoice}
        />
      );
    },
  },
];

export type FieldChoicesProps = {
  autoFocus?: boolean;
  disabled?: boolean;
  label?: string;
  value: {
    label: string;
    value: string | number;
  }[];
  onChange: (
    choices: {
      label: string;
      value: string | number;
    }[],
  ) => void;
  helpText?: string;
};

export const FieldChoices = ({
  autoFocus = false,
  disabled = false,
  label = "Choices",
  value,
  helpText = "Labels will be displayed when editing cells.",
  onChange,
}: FieldChoicesProps) => {
  const items = value.map((choice, idx) => ({
    disabled,
    value: choice.value,
    setValue: (newValue: string) => {
      const newChoices = [...value];
      newChoices[idx].value = newValue;
      newChoices[idx].label = newValue;
      onChange(newChoices);
    },
    removeChoice: () => {
      const newChoices = [...value];
      newChoices.splice(idx, 1);
      onChange(newChoices);
    },
  }));

  return (
    <EuiFormRow fullWidth label={label} helpText={helpText}>
      <>
        <EuiBasicTable
          autoFocus={autoFocus}
          noItemsMessage="No choices found"
          columns={disabled ? [columns[0]] : columns}
          items={items}
        />

        <EuiButtonEmpty
          iconType="plus"
          onClick={() => {
            onChange([...value, { label: "", value: "" }]);
          }}
        >
          Add choice
        </EuiButtonEmpty>
      </>
    </EuiFormRow>
  );
};
